export default __webpack_public_path__ + "static/media/explore10.f4b161bc.png";